import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import salesSlipApi from 'api/salesSlipApi';
import { MESSAGE } from 'constants';
import { setClient } from 'redux/cartSlice';


export const useSalesSlip = (cID = 1, cName = '') => {
    const dispatch = useDispatch();
    var { clientID, clientName } = useSelector((state) => ({ clientID: state.cart.clientID, clientName: state.cart.clientName }));
    if (cID > 5 && cID !== clientID) {
        dispatch(setClient({
            clientID: cID,
            clientName: cName,
        }))
    }

    const location = useLocation();
    const objSearch = useMemo(() => {
        const search = new URLSearchParams(location.search);
        const obj = {
            txtSearch: search.get("search") || '',
        };
        return obj;
    }, [location.search]);

    const [termSearch, setTermSearch] = useState({ txtSearch: objSearch?.txtSearch || '' });
    const [salesSlipList, setSalesSlipList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        title: '',
        type: '',
        contents: []
    });

    const navigate = useNavigate();
    useEffect(() => {
        navigate(`?search=${termSearch.txtSearch}`, { replace: true });
    }, [navigate, termSearch])


    useEffect(() => {

        async function searchSalesSlip() {
            try {
                setIsLoading(true);

                /**Call Api */
                const params = {
                    txtSearch: termSearch?.txtSearch || '',
                    clientID: clientID,
                }
                const dtResponse = await salesSlipApi.search(params);
                const dtSalesSlip = dtResponse?.data['dtSalesSlip'];
                setSalesSlipList(dtSalesSlip);
                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
                const errMsg = {
                    type: MESSAGE.ERROR,
                    contents: [err]
                }
                setMessage(errMsg);
            }
        }

        searchSalesSlip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [termSearch])

    return { clientID, clientName, salesSlipList, termSearch, setTermSearch, isLoading, message, setMessage };
}